import { render, staticRenderFns } from "./SerpResultsListItem.vue?vue&type=template&id=ffc5af80&scoped=true"
import script from "./SerpResultsListItem.vue?vue&type=script&lang=js"
export * from "./SerpResultsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc5af80",
  null
  
)

export default component.exports